const {
    _signRageQuitRequest,
    _multipartyRageQuit,
    _signRageQuitRequestWithPrivateKey
} = require('../logic/multiparty-rage-quit');

class MultipartyRageQuitSubPackage {

    constructor(signer) {
        this.etherSigner = signer;
    }

    signRageQuitRequestWithPrivateKey(stakehouseAddress, blsPublicKey, recipient, deadline, signatureHolder, privateKey, stakehouseKick=null) {
        return _signRageQuitRequestWithPrivateKey(this.etherSigner, stakehouseAddress, blsPublicKey, recipient, deadline, signatureHolder, privateKey, stakehouseKick);
    }

    signRageQuitRequest(provider, signerAddress, stakehouseAddress, blsPublicKey, recipient, deadline, signatureHolder, stakehouseKick=null) {
        return _signRageQuitRequest(provider, signerAddress, stakehouseAddress, blsPublicKey, recipient, deadline, signatureHolder, stakehouseKick);
    }

    multipartyRageQuit(stakehouseAddress, ethRecipient, freeFloatingSlotOwner, authenticatedReport, reportAndTokenHolderSignatures, ethValue, stakehouseKick=null) {
        return _multipartyRageQuit(this.etherSigner, stakehouseAddress, ethRecipient, freeFloatingSlotOwner, authenticatedReport, reportAndTokenHolderSignatures, ethValue, stakehouseKick);
    }
}

module.exports = {
    MultipartyRageQuitSubPackage
};
